import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tagsService } from '../tags.service';
import { BaseCacheService } from './base-cache';
import { userServices } from '../users.service';
import { tasksServices } from '../tasks.service';

@Injectable({
  providedIn: 'root'
})
export class activityTypeCache extends BaseCacheService<any> {
  constructor(private taskService: tasksServices) {
    super();
  }

  protected fetchApiData(): Observable<any[]> {
    return this.taskService.getActivityTypes();
  }
}
